import React from "react"
import "./navbar.css"
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from "react-bootstrap"
import { Link } from "gatsby"

export default function NavbarComp() {
  return (
    <Navbar
      fixed="center"
      collapseOnSelect
      expand="lg"
      bg="success"
      variant="dark"
      style={{ fontSize: "1.5em" }}
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto menuItem">
          <Nav.Link as={Link} activeStyle={{ color: "white" }} to="/">
            Home
          </Nav.Link>
          <Nav.Link as={Link} activeStyle={{ color: "white" }} to="/about">
            About
          </Nav.Link>
          <Nav.Link as={Link} activeStyle={{ color: "white" }} to="/skills">
            Skills
          </Nav.Link>
          <Nav.Link as={Link} activeStyle={{ color: "white" }} to="/projects">
            Projects
          </Nav.Link>
          <Nav.Link as={Link} activeStyle={{ color: "white" }} to="/contact">
            Contact
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}
